import type { UseFetchOptions } from 'nuxt/app'

export function useKftApiFetch<T, Y = T>(
  url: string,
  options: UseFetchOptions<T, Y> = {}
) {
  const config = useRuntimeConfig()
  const { $i18n } = useNuxtApp()
  const { locale: ISOLocale } = $i18n
  const locale = convertISO2Locale(ISOLocale.value)
  const localeBCP47 = convertLocaleIntoBCP47(ISOLocale.value)
  const { apiBaseURL } = config.public

  const nuxt = useNuxtApp()

  let key = url
  if (key[0] === '/') {
    // remove the leading slash so that google does not crawl unwanted urls
    key = key.slice(1)
  }

  const defaults: UseFetchOptions<T, Y> = {
    baseURL: apiBaseURL,
    // cache request
    key,

    headers: {
      'Content-Type': 'application/json',
      'Accept-Language': `${localeBCP47},${locale}`,
    },
    dedupe: 'cancel',
    onResponse(response) {
      const customOnResponse = options.onResponse
      delete options.onResponse

      if (customOnResponse && typeof customOnResponse === 'function') {
        customOnResponse(response)
      }
    },
    getCachedData(key) {
      return nuxt.isHydrating ? nuxt.payload.data[key] : nuxt.static.data[key]
    },
  }

  const fetchOptions = { ...defaults, ...options }

  return useFetch(url, fetchOptions)
}
